var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2V20C2.75 20.6904 3.30964 21.25 4 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V2C1.25 1.58579 1.58579 1.25 2 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7001 9.11714C21.3652 7.45198 22.1969 5.13389 21.9604 2.81697C21.9183 2.40458 21.5954 2.08169 21.183 2.03959C18.8661 1.8031 16.548 2.63477 14.8829 4.29993L13.3472 5.83564L12.3793 5.35836L11.9629 5.18303C11.1907 4.85788 10.2897 5.03932 9.68787 5.64116L8.10301 7.22602C7.92946 7.39957 7.98289 7.69034 8.20556 7.7841L9.43559 8.30204L10.4035 8.77931L10.1128 9.06997C9.86691 9.31588 9.8633 9.71097 10.1048 9.95242L14.0476 13.8952C14.289 14.1367 14.6841 14.1331 14.93 13.8872L15.2207 13.5965L15.698 14.5644L16.2159 15.7944C16.3097 16.0171 16.6004 16.0705 16.774 15.897L18.3588 14.3121C18.9607 13.7103 19.1421 12.8093 18.817 12.0371L18.6416 11.6207L18.1644 10.6528L19.7001 9.11714Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1821 13.8179C11.2726 14.9085 11.2726 16.6767 10.1821 17.7673C9.43819 18.5111 7.25919 18.8527 5.94893 18.9947C5.3983 19.0544 4.94563 18.6017 5.0053 18.0511C5.14729 16.7408 5.48886 14.5618 6.23273 13.8179C7.32331 12.7274 9.09149 12.7274 10.1821 13.8179Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.7f0ea8d07119c001676e79a7ab1a1afd.svg";
export { ForwardRef as ReactComponent };